import { useState } from 'react';
import { apiURL } from '../../consts/URLs';
import { SECURITY_CHECK } from '../endpointList';
import { fetchRequest, getOptions } from '../utils';
import { getCookie } from '../../utils/handleCookie';
import { cookieName } from '../../consts/cookie';

// export interface securityCheck {
//     name: string;
//     ordering: string;
// }

const token = getCookie(cookieName.token);

const useSecurityCheck = () => {
    const [securityCheckResponse, setSecurityCheckResponse] = useState<any>();
    const [securityCheckResult, setSecurityCheckResult] = useState<any>();

    const [getSecurityCheckResponse, setGetSecurityCheckResponse] = useState<any>();
    const [getSecurityCheckResult, setGetSecurityCheckResult] = useState<any>();

    const createSecurityCheck = (status: any) => {
        const url = `${apiURL}/${SECURITY_CHECK}`;
        const options = getOptions({
            method: 'POST',
            token: token,
            body: {
                enabled: status === true ? 1 : 0,
            },
        });
        fetchRequest(url, options, setSecurityCheckResponse, setSecurityCheckResult);
    };

    const getSecurityCheck = () => {
        const url = `${apiURL}/${SECURITY_CHECK}`;
        const options = getOptions({ method: 'GET', token: token });
        fetchRequest(url, options, setGetSecurityCheckResponse, setGetSecurityCheckResult);
    };

    const RESPONSES = {
        securityCheckResponse,
        getSecurityCheckResponse,
    };

    const RESULTS = {
        securityCheckResult,
        getSecurityCheckResult,
    };

    const CTAs = {
        createSecurityCheck,
        getSecurityCheck,
    };

    return { RESPONSES, RESULTS, CTAs };
};
export default useSecurityCheck;
